import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css'

const Games = () => {
    return (
        <App />
    );
}

ReactDOM.render(
    <Games />,
    document.getElementById('root')
);